var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSumInsuredFallingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.62,38.07h.46V203.93h43.25V117.13h-31.15v-14.06h31.65c7.49,0,13.55,6.07,13.56,13.56v87.29h43.21v-52h-31.16v-14h31.64c7.48,.01,13.54,6.07,13.55,13.55v52.45h43.23v-21.27h-32.15v-14.06h32.65c7.48,.01,13.55,6.08,13.56,13.56v21.77c-.02,7.48-4.37,14-14.06,14H49.08c-9.89,0-13.98-6.53-14-14V51.63c0-7.48,6.06-13.54,13.54-13.56Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "184.53 102.88 71.45 52.67 67.13 62.34 180.21 112.55 184.53 102.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.95,96.25l9.28-5.51,15.94,26.91c1.52,2.55,.68,5.86-1.87,7.38-.53,.32-1.11,.54-1.72,.66l-30.68,6.11-2.1-10.59,23.2-4.61-12.06-20.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumInsuredFallingIcon);
export default __webpack_public_path__ + "static/media/SumInsuredFallingIcon.8b20bd8f2ad652913ad32c320520f047.svg";
export { ForwardRef as ReactComponent };